"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconShare = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconShare = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", _objectSpread(_objectSpread({
    width: "24",
    height: "28",
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M24 16C24 15.4477 23.5523 15 23 15C22.4477 15 22 15.4477 22 16H24ZM1 25H0H1ZM2 16C2 15.4477 1.55228 15 1 15C0.447715 15 0 15.4477 0 16H2ZM22 16V25H24V16H22ZM22 25C22 25.2652 21.8946 25.5196 21.7071 25.7071L23.1213 27.1213C23.6839 26.5587 24 25.7957 24 25H22ZM21.7071 25.7071C21.5196 25.8946 21.2652 26 21 26V28C21.7957 28 22.5587 27.6839 23.1213 27.1213L21.7071 25.7071ZM21 26H3V28H21V26ZM3 26C2.73478 26 2.48043 25.8946 2.29289 25.7071L0.87868 27.1213C1.44129 27.6839 2.20435 28 3 28V26ZM2.29289 25.7071C2.10536 25.5196 2 25.2652 2 25H0C0 25.7956 0.31607 26.5587 0.87868 27.1213L2.29289 25.7071ZM2 25V16H0V25H2Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M2 11L11.293 1.707C11.4805 1.51953 11.7348 1.41422 12 1.41422C12.2652 1.41422 12.5195 1.51953 12.707 1.707L22 11",
      stroke: color,
      strokeWidth: "2",
      "stroke-linecap": "round"
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M12 1V22",
      stroke: color,
      strokeWidth: "2",
      "stroke-linecap": "round"
    }, void 0)]
  }), void 0);
});